import { render, staticRenderFns } from "./BrandLavista.vue?vue&type=template&id=2b36597f&scoped=true&"
import script from "./BrandLavista.vue?vue&type=script&lang=js&"
export * from "./BrandLavista.vue?vue&type=script&lang=js&"
import style0 from "./BrandLavista.vue?vue&type=style&index=0&id=2b36597f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36597f",
  null
  
)

export default component.exports